
let debug: boolean = false
let host: string = ``
let hostIM = 'https://im.aqlearn.com';
let sys_name: string = '安培通网校-双师课堂';
let sys_logo: string = 'https://apttest.oss-cn-hangzhou.aliyuncs.com/2330e787-25c6-44d9-995f-0ee59471f9f1.png';
let tel: string = '0571-86816997';
let phone: string = '13605806160';

if (['3010', '3014', '3011'].includes(window.location.port)) {
  debug = true
}

if (debug) {
  host = `${window.location.origin}`
} else {
  host = `${window.location.origin}`
}

const config = {
  debug,
  host,
  sys_name,
  sys_logo,
  tel,
  phone,
  hostIM,
}

export default config